import { LOGIN_USER, SET_CURRENT_USER, SET_USER_DETAIL } from '../../constants';
import { createAction } from 'redux-actions';
import { loginUserRequest } from './authMethods';
import { urlLoginUsers } from '../urls';

export const loginUser = createAction(LOGIN_USER, (user) =>
  loginUserRequest(urlLoginUsers, user)(),
);

export const setCurrentUser = createAction(SET_CURRENT_USER, (authData) => authData);

export const setUserDetail = createAction(SET_USER_DETAIL, (userDetail) => userDetail);
